
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { MixinsHomeClick } from '@xt/client/mixins/home'
import type { NewCourseCardType } from '@xt/client/types/home'

@Component({
  components: {
    LazyImg
  }
})
export default class HeadCard extends Mixins(MixinsHomeClick) {
  @Prop() dataSource: Array<NewCourseCardType>

  get isEmpty() {
    return this.dataSource.length === 0
  }

  get isOnlyOne() {
    return this.dataSource.length === 1
  }

  handleClick(index: number) {
    if (this.dataSource[index].event) {
      this.onClickEvent(this.dataSource[index].event)
      return
    }

    if (this.dataSource[index].pop) {
      this.$emit('open-pop', this.dataSource[index].pop)
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
